import { createContext, useContext, useState, useEffect, ReactNode } from 'react'
import { CORRECT_PASSWORD } from '../constants/auth'

interface AuthContextType {
  isAuthenticated: boolean
  isCheckingAuth: boolean
  login: () => void
  logout: () => void
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

interface AuthProviderProps {
  children: ReactNode
}

export function AuthProvider({ children }: AuthProviderProps) {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isCheckingAuth, setIsCheckingAuth] = useState(true)

  useEffect(() => {
    // Check if user is already authenticated on app load
    const checkAuthStatus = () => {
      // Migration: Check old password storage and convert to new flag system
      const oldAuth = localStorage.getItem('wedding-auth')
      if (oldAuth === CORRECT_PASSWORD) {
        localStorage.setItem('wedding-authenticated', 'true')
        localStorage.removeItem('wedding-auth') // Clean up old storage
      }
      
      const isAuthenticated = localStorage.getItem('wedding-authenticated') === 'true'
      setIsAuthenticated(isAuthenticated)
      setIsCheckingAuth(false)
    }

    checkAuthStatus()
  }, [])

  const login = () => {
    localStorage.setItem('wedding-authenticated', 'true')
    setIsAuthenticated(true)
  }

  const logout = () => {
    localStorage.removeItem('wedding-authenticated')
    setIsAuthenticated(false)
  }

  return (
    <AuthContext.Provider value={{ isAuthenticated, isCheckingAuth, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
